// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl : 'https://api.radarqr.com/v1/api',
  // apiUrl:"http://112.196.26.154:3800/v1/api",
  BUCKET_NAME:"prod-radarqr-images-original",
  IDENTITY_POOL_ID:"us-west-2:d7459fb4-fe0f-4e56-b397-8c138f8cb4dc",
  VENUE_IMAGE_BUCKET_ORIGINAL:"prod-radarqr-venues-images-original",
  REGION:"us-west-2",
  PROFILE_URL:"https://profile.radarqr.com/user",
  qrCodeBaseUrl:"https://profile.radarqr.com/user",
  HOTSPOT_URL: "https://profile.radarqr.com/hotspot"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
